import { TFunction } from 'next-i18next';

export const trackingFormRules = (t: TFunction) => ({
  trackingCode: [
    { required: true, message: t('tracking:tracking.validation.requiredTracking') },
    { min: 13, message: t('common:validation.length', { characters: 13 }) },
  ],
});
